import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../lib/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
  showMicrocopy?: boolean;
}
export function CTAButton({
  children,
  href = 'https://www.tumundoequilibrado.com/cart/51386600358183:1',
  className = '',
  fullWidth = false,
  showMicrocopy = true
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center gap-3 ${fullWidth ? 'w-full' : ''}`} data-id="element-80">
      <motion.a href={href} onClick={() => trackAddToCart()} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`
          inline-flex items-center justify-center gap-3 
          bg-coral hover:bg-coral-dark text-white 
          px-8 py-5 rounded-xl font-sans font-bold text-lg md:text-xl
          shadow-soft transition-colors text-center
          ${fullWidth ? 'w-full' : 'w-full md:w-auto'}
          ${className}
        `} data-id="element-81">
        {children}
      </motion.a>

      {showMicrocopy && <p className="font-sans text-sm text-ink-light font-medium flex items-center justify-center flex-wrap gap-2" data-id="element-82">
          <span data-id="element-83">🔒 Pago seguro</span>
          <span className="hidden md:inline" data-id="element-84">•</span>
          <span data-id="element-85">📥 PDF instantáneo</span>
          <span className="hidden md:inline" data-id="element-86">•</span>
          <span data-id="element-87">✅ Sin suscripciones</span>
        </p>}
    </div>;
}